import { httpGet, httpPut, httpDelete, httpPost } from '../../../util/request.js';
import appConfig from '../../../config';

export default class SmploginApi {

	static SMPLOGIN_API_URL = appConfig.gatewayUrl + appConfig.smpServicePath + "/smpLogin";

	static smplogin() {
		let params = { appCode: appConfig.appCode, scope: appConfig.scope, grantType: appConfig.grantType };
		return httpPost(SmploginApi.SMPLOGIN_API_URL, params);
	}

}